import { Fragment } from 'react';
import AccordionCohabitatonData from 'cohabitation/components/shared/cohabitation-data';
import AccordionCohabitaton from 'cohabitation/components/shared/accordion-cohabitation';
import EditData from './edit-data';

interface CohabitationDetailStepProps {
  stepState: number;
}

const CohabitatonDetailStep = ({ stepState }: CohabitationDetailStepProps): React.ReactElement => {
  return (
    <Fragment>
      {stepState === 0 ? (
        <>
          <AccordionCohabitatonData disabled />
          <EditData disabled />
          <AccordionCohabitaton disabled isCancellation />
        </>
      ) : undefined}
    </Fragment>
  );
};

CohabitatonDetailStep.displayName = 'Cohabitation Detail step component';

export default CohabitatonDetailStep;
